// Shared, non-reactive flag so a navigation trigger that already asked the
// user "leave without saving?" (e.g. the sidebar) can tell the editor's own
// router-level useBlocker not to ask a second time for the same navigation.
let leaveConfirmed = false;

export const markLeaveConfirmed = () => {
  leaveConfirmed = true;
};

export const consumeLeaveConfirmed = () => {
  const was = leaveConfirmed;
  leaveConfirmed = false;
  return was;
};
